<div class="related-description" aria-live="polite">
  @if (isLoading) {
    <div class="description-status">
      <span class="description-spinner" aria-hidden="true"></span>
      <span>מחפשים תיאור מתאים לרכב...</span>
    </div>
  } @else if (loadError) {
    <div class="description-status error-status" role="alert">
      <span>לא הצלחנו לטעון את התיאורים.</span>
      <button type="button" class="retry-button" (click)="retry()">נסו שוב</button>
    </div>
  } @else if (!hasRequiredSelections) {
    <div class="description-status muted-status">
      <span class="status-number" aria-hidden="true">1</span>
      <span>בחרו יצרן, דגם ושנה כדי לראות תיאורים מתאימים.</span>
    </div>
  } @else if (descriptionList.length === 0) {
    <div class="description-status muted-status">
      <span class="empty-icon" aria-hidden="true">—</span>
      <span>לא נמצאו תיאורים מתאימים לבחירה.</span>
    </div>
  } @else {
    <div class="description-summary">
      <span class="summary-copy">
        <span class="summary-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M4 15.5V12l2-5h12l2 5v3.5M6.5 17.5h.01M17.5 17.5h.01M5 12h14M7 7l1.2-2h7.6L17 7M5 15.5v2.3A1.2 1.2 0 0 0 6.2 19h.6A1.2 1.2 0 0 0 8 17.8V17h8v.8a1.2 1.2 0 0 0 1.2 1.2h.6a1.2 1.2 0 0 0 1.2-1.2v-2.3"></path>
          </svg>
        </span>
        <span>
          <strong>בחרו את התיאור המדויק ביותר</strong>
          <small>השוו בין פרטי הרכב ולחצו על האפשרות המתאימה</small>
        </span>
      </span>
      <span class="result-count">{{ descriptionList.length }} אפשרויות</span>
    </div>

    <div class="description-grid" role="listbox" aria-label="תיאורי רכב מתאימים">
      @for (description of descriptionList; track description.label; let i = $index) {
        <button
          type="button"
          class="description-option"
          [class.is-selected]="isSelected(description)"
          [attr.aria-selected]="isSelected(description)"
          role="option"
          (click)="selectDescription(description)">
          <span class="option-radio" aria-hidden="true">
            <svg viewBox="0 0 20 20"><path d="M4.5 10.2l3.2 3.2 7.8-7.8"></path></svg>
          </span>
          <span class="option-content">
            <strong class="option-title">{{ description.title }}</strong>
            @for (detail of description.details; track detail) {
              <span class="option-detail">{{ detail }}</span>
            }
          </span>
          <span class="option-number" aria-hidden="true">
            @if (isSelected(description)) { נבחר } @else { {{ i + 1 }} }
          </span>
        </button>
      }
    </div>
  }
</div>
